import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { api, imgUrl } from "@/lib/api";
import { useLang } from "@/i18n";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.get("/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  if (clients.length === 0) return null;

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="bg-[#0B1120] px-6 md:px-12 lg:px-24 py-20 lg:py-28"
    >
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4 text-center">
          {t("clients_label")}
        </p>
        <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl tracking-tight text-center mb-4">
          {t("clients_title").replace(".", "")}<span className="text-[#FFC61A]">.</span>
        </h2>
        <div className="w-16 h-1 bg-gradient-to-r from-[#ED1C24] to-[#FFC61A] mx-auto mb-16" />
      </Reveal>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
        {clients.map((c, i) => (
          <Reveal key={c.id} delay={(i % 5) * 0.06}>
            <div
              data-testid={`client-card-${i}`}
              className="group bg-white rounded-xl p-6 h-36 flex flex-col items-center justify-center gap-3 hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(237,28,36,0.15)] transition-[transform,box-shadow] duration-500"
            >
              {c.logo ? (
                <img
                  src={imgUrl(c.logo)}
                  alt={c.name}
                  loading="lazy"
                  className="max-h-14 max-w-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
              ) : null}
              <p className="text-xs font-medium text-slate-700 text-center leading-tight">{c.name}</p>
              {c.partner_type && (
                <span data-testid={`client-badge-${i}`} className="inline-block text-[9px] tracking-[0.12em] uppercase text-[#ED1C24] border border-[#ED1C24]/25 px-2 py-0.5">
                  {c.partner_type}
                </span>
              )}
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="text-center mt-14">
          <p className="text-slate-400 text-sm mb-4">{t("clients_partner_hint")}</p>
          <Link
            data-testid="clients-partner-cta"
            to="/partner"
            className="inline-block bg-[#ED1C24] hover:bg-[#C81016] text-white text-sm font-medium px-8 py-3.5 transition-colors duration-300"
          >
            {t("clients_partner_cta")}
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
